var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 421,
    viewBox: "0 0 434 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 100.16C8.1496 90.5255 15.619 78.0458 23.0884 68.062",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7305 58.077C43.8393 38.9414 65.4175 18.9739 83.5474 9.47107",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.116 6.34436C102.261 16.5076 61.2627 41.4371 44.6641 68.8925",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6016 107.975C24.5693 98.0152 32.2223 84.701 38.0319 78.0452",
    stroke: "#FF9F19",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1382 119.703C9.45903 132.993 6.33959 152.538 4 165.046",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6133 205.341C19.2526 185.536 28.0129 146.286 33.6279 133.777",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5469 122.051C41.8392 111.908 47.9988 96.3508 54.6383 88.031",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1016 77.2126C82.8498 46.4293 124.346 24.7978 150.621 18.8536",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3906 226.968C34.77 213.678 38.6386 211.097 40.655 183.809C42.2147 162.701 57.9484 114.651 72.0572 99.6752",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1836 86.3635C101.102 55.5802 151.728 33.9487 178.69 30.5785",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3203 245.276C57.2384 216.35 56.2445 196.323 63.2633 170.524",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3984 158.794C70.7481 145.713 77.8748 122.143 90.3238 110.495",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9531 99.6802C123.511 64.7369 170.817 48.9293 195.067 47.0021",
    stroke: "#DE3835",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9258 259.419C67.085 245.086 73.408 230.717 77.3073 208.827",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.875 194.753C78.875 178.335 86.491 147.157 104.428 122.139",
    stroke: "#FF9F19",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.848 112.67C134.244 82.1801 172.457 66.5443 207.551 64.9807",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M226.258 64.1961C256.297 62.2342 310.243 88.0253 324.352 113.818",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M330.988 122.97C336.798 130.457 343.437 143.769 348.692 161.919",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M352.59 175.214C354.409 183.292 355.883 228.636 345.094 266.907",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M343.45 278.557C340.331 294.193 339.349 294.047 335.449 308.901",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8633 272.732C82.8024 257.878 91.189 235.1 93.6846 221.341",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5781 205.701C100.698 179.12 102.247 158.858 120.184 134.622",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.832 124.64C140.09 110.568 174.831 84.705 211.485 84.705",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M223.102 84.705C248.837 84.705 282.857 95.5207 304.435 124.64",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M311.91 132.956C321.869 146.268 330.169 162.075 333.105 182.249",
    stroke: "#DE3835",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M333.495 195.356C335.055 205.519 335.985 226.139 328.516 256.923",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M325.178 267.743C320.498 285.984 314.382 312.029 307.363 333.138",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1328 295.609C94.2032 289.664 99.8452 276.796 101.94 270.233M136.797 146.268C115.219 172.891 124.348 206.171 105.259 258.585",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M211.48 103.007C186.404 103.007 160.887 115.773 145.086 134.02",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M308.585 256.923C301.566 296.794 280.851 351.114 276.172 366.749",
    stroke: "#A3A3A3",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.635 200.352C212.516 229.278 205.207 275.287 189.609 320.63",
    stroke: "#ADADAD",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M184.932 333.131C178.693 347.985 167.463 375.348 166.215 378.475",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M151.719 360.089C174.957 315.994 189.066 250.268 194.278 225.247",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M195.84 211.175C197.083 192.892 204.839 181.214 218.948 181.213C233.057 181.212 239.512 193.977 234.833 215.867",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M233.892 229.464C231.963 242.204 223.933 271.063 218.953 291.031",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M210.655 318.492C200.696 350.108 193.226 370.075 180.777 396.699",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M197.379 409.177C204.018 394.201 205.678 390.041 212.318 370.906",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M219.785 352.601C227.064 331.493 251.323 239.452 253.812 221.98",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M222.262 162.078C228.116 162.345 233.432 164.675 238.03 168.207",
    stroke: "#FF9F19",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M191.559 168.568C195.774 164.486 203.178 161.242 211.477 161.242",
    stroke: "#FF9F19",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M174.137 213.659C175.891 197.831 180.786 183.348 184.096 177.883",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M173.309 226.969C169.159 260.248 153.736 309.676 137.359 346.42",
    stroke: "#A3A3A3",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M122.664 332.632C137.642 298.599 145.902 264.409 151.712 238.618",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M252.969 156.253C245.5 149.597 236.371 143.773 222.262 142.941",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 142.941C201.531 142.941 188.252 147.101 176.633 158.749",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M169.991 167.898C156.712 188.697 155.052 209.497 152.563 225.305",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M211.491 123.802C194.062 123.802 174.974 129.626 160.035 147.748",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M255.694 210.497C256.987 200.563 255.693 183.71 246.343 175.391",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M260.457 164.573C268.756 172.892 278.716 197.852 272.906 223.643",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M269.582 235.291C263.773 276.89 232.894 378.405 217.297 417.495",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M107.734 314.327C116.831 292.607 121.013 280.216 128.483 253.592",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M130.961 241.947C132.621 224.475 141.306 183.678 155.029 157.917",
    stroke: "#FF9F19",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M222.262 123.802C244.67 125.465 259.609 132.121 272.058 145.433",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M279.535 154.588C291.233 170.224 296.964 211.995 291.984 234.459",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M288.665 246.107C285.345 266.907 281.63 280.755 271.492 315.154",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M267.605 326.881C257.97 360.924 253.069 373.797 241.371 405.851",
    stroke: "#A8A8A8",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M234.848 45.4332C257.464 45.4332 311.081 59.7427 338.469 98.8458",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M365.074 275.282C370.533 249.483 372.093 235.411 374.433 214.302",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M375.225 201.011C375.225 174.556 361.71 127.965 347.602 111.325",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M252.789 29.0201C275.405 31.3655 317.518 42.3106 354.951 87.6543",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M363.359 98.8477C372.489 111.327 396.557 156.254 392.407 219.485",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M270.703 12.5999C292.539 17.2906 350.072 43.1037 372.48 77.215",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M381.602 88.859C391.561 103.835 400.69 126.298 404.051 140.811",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M407.188 153.325C411.867 172.87 412.647 188.505 411.087 217.432",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M300.352 4C322.188 9.47253 370.831 37.2793 389.089 69.7266",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M397.383 81.3734C410.662 103.005 428.242 147.067 428.242 175.993",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M351.031 11.0343C364.029 18.0704 387.419 33.1176 402.357 58.909",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M409 68.8956C414.81 77.2155 425.899 100.163 430.579 114.235",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M222.262 103.007C247.27 103.007 273.717 114.655 287.826 134.623",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M294.477 143.775C314.395 172.062 317.715 216.157 311.075 245.277",
    stroke: "#00AB5B",
    strokeWidth: 6.5998,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M101.936 267.525L91.9766 294.082",
    stroke: "#A3A3A3",
    strokeWidth: 6.70804,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.63d35fe261bb49cdea46cda54d828bae.svg";
export { ForwardRef as ReactComponent };